import React from 'react'
import { useHistory } from 'react-router-dom'
import { Wrapper } from './styled'
import { Button } from 'lib/ui/components'

export const EmptyColumn = () => {
  const history = useHistory()
  return (
    <Wrapper>
      <h3>Add another product<br />to compare.</h3>
      <Button
        className='outlined'
        skin={Button.SKIN.OUTLINE}
        onClick={() => history.push('/')}
      >
        Back to Home
      </Button>
    </Wrapper>
  )
}
